export enum ScheduledReportSingleDayEnum {
	Today = 0,
	Yesterday = 10,
	XDaysBeforeReportRun = 20,
}